import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-setting-push-notifications",
  templateUrl: "./setting-push-notifications.component.html",
  standalone:false,
  styleUrls: ["./setting-push-notifications.component.scss"],
})
export class SettingPushNotificationsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  constructor(
    private location: Location,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.toastr.success(
      "You have successfully update your push notifications",
      "Push notifications updated"
    );
  }

  async ngOnInit(): Promise<void> {}

  settingEditPrimary() {
    this.router.navigateByUrl("/SettingEditPrimary");
  }
  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this.location.back();
  }
}

